var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', {
    staticClass: "mb-40 mb-lg-80",
    attrs: {
      "show-arrows": "",
      "center-active": ""
    }
  }, [_c('v-chip', {
    staticClass: "justify-center",
    attrs: {
      "to": {
        path: '/lectures'
      },
      "exact": "",
      "x-large": "",
      "active-class": "primary"
    }
  }, [_c('span', [_vm._v("전체 ")])]), _vm._l(_vm.items, function (item) {
    return [_c('v-chip', {
      key: item._id,
      staticClass: "justify-center",
      class: {
        primary: _vm.$route.path == '/lectures' && _vm.$route.query.category == item.code
      },
      attrs: {
        "to": {
          path: '/lectures',
          query: {
            category: item.code
          }
        },
        "exact": "",
        "x-large": "",
        "active-class": "primary"
      }
    }, [_c('span', [_vm._v(" " + _vm._s(item.name) + " ")])])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }